import React from 'react';
import classes from './style.module.css'
import { JOCKEY_TABLE_COLUMNS_ALL } from '../../../constants/Constants'
import WinDetailCell from './WinDetailCell';
import OddResultCell from './OddResultCell';

const League = (props) => {
    const rowIndex = props.index + 1;
    const id = props.item.id;

    const columnList = props.finalColumns;
    const ticklerTab = props.ticklerTab;

    const filterHorseCoulmn = (column) => {
        return ((ticklerTab.id === 'COURSE_DISTANCE' || ticklerTab.id === 'LONGEST_TRAVELLER' ||
            ticklerTab.id === 'FIRST_TIME_VISORS' || ticklerTab.id === 'FIRST_TIME_BLINKERS' ||
            ticklerTab.id === 'CHEEK_PIECE' || ticklerTab.id === 'TONGUE_STRAP')
            && (column === 'HORSE'))
    }

    const filterDaysSinceLastRunCoulmn = (column) => {
        return ((ticklerTab.id === 'HOT_JOCKEY' || ticklerTab.id === 'HOT_TRAINER')
            && (column == 'DAYS_SINCE_LAST_RUN'))
    }

    const cells = columnList.filter(x => !filterHorseCoulmn(x.id)).filter(x => !filterDaysSinceLastRunCoulmn(x.id)).map(column => {
        let cell = null;
        const cellKey = id + "_" + column.id
        switch (column.id) {
            case JOCKEY_TABLE_COLUMNS_ALL.ROW_NUM.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{rowIndex}</th>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.NAME.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.name}</td>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.WINS.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.wins}</td>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.RIDES.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.rides}</td>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.WIN_PERCENT.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.winPercent}</td>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.PLACE.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.place}</td>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.PLACE_PERCENT.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.placePercent}</td>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.RACE.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.race}</td>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.HORSE.id:
                let name = props.item.runner ? props.item.runner.runnerName : '-';
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{name}</td>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.AGE.id:
                let age = props.item.runner && props.item.runner.metadata ? props.item.runner.metadata["AGE"] : '-';
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{age}</td>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.DAYS_SINCE_LAST_RUN.id:
                    let daysSinceLastRun = props.item.runner && props.item.runner.metadata ? props.item.runner.metadata["DAYS_SINCE_LAST_RUN"] : '-';
                    cell = <td key={cellKey} className={classes.LeagueTdTh}>{daysSinceLastRun}</td>
                    break;
            case JOCKEY_TABLE_COLUMNS_ALL.FORM.id:
                let form = props.item.runner && props.item.runner.metadata ? props.item.runner.metadata["FORM"] : '-';
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{form}</td>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.ODD_DETAILS.id:
                let part = props.item;
                let details = "-"
                if (part.runner && part.runner.selectionId && part.eventDetails && part.eventDetails.bfMarketId) {
                    details = <OddResultCell date={props.date} oddChangeCallback={props.oddChangeCallback} marketId={part.eventDetails.bfMarketId} selectionId={part.runner.selectionId} />
                }
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{details}</td>
                break;
            case JOCKEY_TABLE_COLUMNS_ALL.WIN_DETAILS.id:
                let currentItem = props.item;
                let winnerDetails = "-"
                if (currentItem.runner && currentItem.runner.selectionId && currentItem.eventDetails && currentItem.eventDetails.bfMarketId) {
                    winnerDetails = <WinDetailCell marketId={currentItem.eventDetails.bfMarketId}
                        date={props.date}
                        selectionId={currentItem.runner.selectionId} />
                }
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{winnerDetails}</td>
                break;
            default:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>-</td>
        }
        return cell;
    })

    return (
        <tr className={classes.League}>
            {cells}
        </tr>
    )
}

export default League;